import { useState } from "react";
import "./PhotoGallery.css";
import photo1 from '../images/img1.jpeg';
import photo2 from '../images/WhatsApp Image 2026-02-05 at 12.15.39 (2).jpeg';
import photo3 from '../images/WhatsApp Image 2026-02-05 at 12.15.40.jpeg';
import photo4 from '../images/WhatsApp Image 2026-02-05 at 12.15.40 (1).jpeg';
import photo5 from '../images/WhatsApp Image 2026-02-05 at 12.15.40 (2).jpeg';
import photo6 from '../images/WhatsApp Image 2026-02-05 at 12.15.40 (3).jpeg';
import photo7 from '../images/WhatsApp Image 2026-02-05 at 12.15.40 (4).jpeg';
import photo8 from '../images/WhatsApp Image 2026-02-05 at 12.15.41.jpeg';

const PhotoGallery = ({ onNext, onBack }) => {
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  // Replace these with your actual photo paths - Updated to 8 photos
  const photos = [
    {
      id: 1,
      url: photo1,
      caption: "Our first date together"
    },
    {
      id: 2,
      url: photo2,
      caption: "That contagious smile"
    },
    {
      id: 3,
      url: photo3,
      caption: "Forever and always"
    },
    {
      id: 4,
      url: photo4,
      caption: "You and me"
    },
    {
      id: 5,
      url: photo5,
      caption: "Walks with you>>>"
    },
    {
      id: 6,
      url: photo6,
      caption: "My favorite person"
    },
    {
      id: 7,
      url: photo7,
      caption: "Beautiful memories"
    },
    {
      id: 8,
      url: photo8,
      caption: "Facials day"
    }
  ];

  return (
    <section className="photo-gallery-section">
      <div className="gallery-container">
        <div className="gallery-header">
          <button className="btn-secondary header-back-btn" onClick={onBack}>
            ← Back
          </button>
          <div className="gallery-header-content">
            <h2 className="section-title">Our Memories</h2>
            <p className="gallery-subtitle">Every moment with you is a treasure</p>
          </div>
          <button className="btn-primary header-continue-btn" onClick={onNext}>
            Continue →
          </button>
        </div>

        <div className="photo-grid">
          {photos.map((photo) => (
            <div
              key={photo.id}
              className="photo-item"
              onClick={() => setSelectedPhoto(photo)}
            >
              <div className="photo-wrapper">
                <img 
                  src={photo.url} 
                  alt={photo.caption}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="photo-placeholder" style={{ display: 'none' }}>
                  <span>📸</span>
                </div>
                <div className="photo-overlay">
                  <p className="photo-caption">{photo.caption}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {selectedPhoto && (
          <div className="photo-modal" onClick={() => setSelectedPhoto(null)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={() => setSelectedPhoto(null)}>
                ×
              </button>
              <img src={selectedPhoto.url} alt={selectedPhoto.caption} />
              <p className="modal-caption">{selectedPhoto.caption}</p>
            </div>
          </div>
        )}

        <div className="nav-buttons"></div>
      </div>
    </section>
  );
};

export default PhotoGallery;
